import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { inject } from '@angular/core';

export const isAuthGuard: CanActivateFn = () => {

  const _authenticacionService = inject(AuthenticationService);
  const router = inject(Router);

  if (_authenticacionService.isAuthenticated$.value) {
    return true;
  } else {
    router.navigate(['']);
    return false;
  }
};
